import { Command } from 'commander';
const pkg = require('../../package.json');

export function VersionCommand(): Command {
  return new Command('version')
    .alias('v')
    .description('Show CLI version')
    .action(() => {
      console.log(pkg.version);
    });
}
